/**
 * ExpertiseV2Tab — the merged Expertise V2 encoding tool, shown as a
 * FULL-PAGE takeover (covers the admin chrome). The "Retour à l'app" button
 * is rendered natively at the top of the V2 sidebar (WorkspaceShell), wired
 * through ExpertiseBackContext — so there's no separate top bar here.
 *
 * V2Page reads the `:affaireId` route param via useParams(), which the
 * affaire-detail route (/admin/affaire/:affaireId) already provides. Lazy-
 * loaded so the Mapbox/expertise bundle only loads when this tab is opened.
 */
import React, { Suspense } from 'react';
import { ExpertiseBackContext } from '@expertise/app/ExpertiseBackContext';

const V2Page = React.lazy(
  () => import('@expertise/features/fiche/steps/photos-workspace/V2Page'),
);

export interface ExpertiseV2TabProps {
  /** Leave the full-page editor and return to the rest of the app. */
  onBack?: () => void;
}

export const ExpertiseV2Tab: React.FC<ExpertiseV2TabProps> = ({ onBack }) => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 1000,
      background: '#fff',
      overflow: 'auto',
    }}
  >
    <ExpertiseBackContext.Provider value={onBack ?? null}>
      <Suspense
        fallback={
          <div style={{ padding: 40, color: '#64748b' }}>
            Chargement de l'expertise…
          </div>
        }
      >
        <V2Page />
      </Suspense>
    </ExpertiseBackContext.Provider>
  </div>
);

export default ExpertiseV2Tab;
